/**
 * MFA session API paths (auth service).
 */
export const MFA_SESSION_BASE_PATH = '/auth/v1/mfa/session'

export const MFA_SESSION_ENDPOINTS = {
  init: `${MFA_SESSION_BASE_PATH}/init`,
  step: `${MFA_SESSION_BASE_PATH}/step`,
  stepAction: `${MFA_SESSION_BASE_PATH}/step/action`,
  stepTransition: `${MFA_SESSION_BASE_PATH}/step/transition`,
  cancel: `${MFA_SESSION_BASE_PATH}/cancel`,
}
